import React from "react";
import { Search, X } from "lucide-react";

const norm = (s) => String(s || "").replace(/'/g, "").replace(/’/g, "").replace(",", ".").trim().toLowerCase();

/** Textsuche über Felder + Beträge: Teilstring in Text/Datum/Nr., Betrag exakt oder als Präfix («830» findet 830.15). */
export function matchesSearch(fields, amounts, query) {
  const q = norm(query);
  if (!q) return true;
  const hay = (fields || []).filter((v) => v != null && v !== "").map((v) => {
    if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}/.test(v)) return `${v} ${new Date(v).toLocaleDateString("de-CH")}`;
    return String(v);
  }).join(" ").toLowerCase();
  if (hay.includes(q)) return true;
  const num = parseFloat(q);
  if (Number.isNaN(num)) return false;
  return (amounts || []).some((a) => a != null && (Math.abs(Math.abs(Number(a)) - Math.abs(num)) < 0.005 || Math.abs(Number(a)).toFixed(2).startsWith(q)));
}

export function ListSearch({ value, onChange, placeholder = "Suchen …", count, testid = "list-search", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400 pointer-events-none" />
      <input type="text" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
        className="w-full rounded-md border border-slate-200 bg-white pl-8 pr-8 py-1.5 text-xs placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-900"
        data-testid={testid} />
      {value && (
        <button type="button" onClick={() => onChange("")} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" title="Suche löschen" data-testid={`${testid}-clear`}>
          <X className="h-3.5 w-3.5" />
        </button>
      )}
      {value && count != null && <div className="absolute -bottom-4 left-0 text-[11px] text-slate-500 whitespace-nowrap" data-testid={`${testid}-count`}>{count} Treffer</div>}
    </div>
  );
}
